require('es6-shim');


//////////////////
// WEBPACK FOOTER
// ./app/polyfills.js
// module id = 0
// module chunks = 0